import { useState } from 'react';
import { authService } from '../services/api';

/**
 * Hook para validar bot do Telegram antes de enviar mídias
 * 
 * Uso:
 * const { validate, loading, error } = useTelegramValidation();
 * 
 * await validate(botId, { vip_id: '-1001234567890', logs_id: '-1001234567891' });
 */
export function useTelegramValidation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const validate = async (botId, { vip_id, logs_id } = {}) => {
    setLoading(true);
    setError(null);

    try {
      if (!botId) {
        throw new Error('bot_id é obrigatório');
      }

      // vip_id e logs_id são opcionais - se nenhum for informado, não há o que validar
      if (!vip_id && !logs_id) {
        return { success: true, data: { validations: {} } };
      }

      // ✅ Usar o método correto do authService
      const response = await authService.validateTelegramBot(botId, {
        vip_id,
        logs_id
      });

      const data = response.data;

      // ✅ Valida resposta
      const validations = data.validations || {};
      const hasErrors = Object.values(validations).some(v => v.status !== 'valid');

      if (hasErrors) {
        const errorMessages = Object.entries(validations)
          .filter(([_, v]) => v.status !== 'valid')
          .map(([key, v]) => `${key}: ${v.error || v.message}`)
          .join('\n');

        throw new Error(errorMessages);
      }

      return { success: true, data };

    } catch (err) {
      const errorMessage = err.response?.data?.error || err.message || 'Erro ao validar bot';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    validate,
    loading,
    error,
    clearError: () => setError(null)
  };
}